export const actionTypes = {
	SET_FALLBACK_WEB3: 'SET_FALLBACK_WEB3',
	SET_CONTRACT: 'SET_CONTRACT',
	SET_BBIT_BALANCE: 'SET_BBIT_BALANCE',
	SET_ETHER_BALANCE: 'SET_ETHER_BALANCE',
	SET_GAS: 'SET_GAS',
	SET_ZARELA_CURRENT_DAY: 'SET_ZARELA_CURRENT_DAY',
	SET_ERROR: 'SET_ERROR',
	SET_CLIENT_DEVICE: 'SET_CLIENT_DEVICE',
	SET_MOBILE_SEARCH_MODAL_SHOW: 'SET_MOBILE_SEARCH_MODAL_SHOW',
	SET_GUIDE_IS_OPEN: 'SET_GUIDE_IS_OPEN',
	SET_NOTIFICATION_COUNT: 'SET_NOTIFICATION_COUNT',
	SET_ETH_PRICE: 'SET_ETH_PRICE',
	SET_OLD_DATA_FORM: 'SET_OLD_DATA_FORM'
};
